import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { fontStyles } from '../constants/styles';
import { isInternalURI } from '../helpers/location';
import { customMarkdown } from '../helpers/markdown';

import ExternalLink from './ExternalLink';
import LocalisedLink from './LocalisedLink';


const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;

  margin-top: 1.25rem;
  ${fontStyles.bodySmall}
  span {
    ${fontStyles.body}
  }
`;

const ImageTitleCaption = ({ caption, title, url }) => {
  if (!caption && !title) return null;

  return (
    <Wrapper>
      <If condition={title}>
        <span>
          <Choose>
            <When condition={url}>
              <Choose>
                <When condition={isInternalURI(url)}>
                  <LocalisedLink hasUnderline={false} to={url}>{title}</LocalisedLink>
                </When>
                <Otherwise>
                  <ExternalLink hasUnderline={false} href={url}>{title}</ExternalLink>
                </Otherwise>
              </Choose>
            </When>
            <Otherwise>
              {title}
            </Otherwise>
          </Choose>
        </span>
      </If>
      <If condition={caption}><div>{customMarkdown(caption)}</div></If>
    </Wrapper>
  );
};


ImageTitleCaption.propTypes = {
  caption: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

export default ImageTitleCaption;
